import { render, staticRenderFns } from "./MyAccountInputs.vue?vue&type=template&id=9c6f5294&"
import script from "./MyAccountInputs.vue?vue&type=script&lang=ts&"
export * from "./MyAccountInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports